import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79fef350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  key: 0,
  class: "fas fa-eye-slash hidden"
}
const _hoisted_4 = { class: "pkg-id" }
const _hoisted_5 = {
  key: 0,
  class: "pkg-id"
}
const _hoisted_6 = {
  key: 1,
  class: "pkg-time"
}
const _hoisted_7 = {
  key: 0,
  class: "field has-addons right"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "~Add Tag~", -1))
const _hoisted_11 = {
  key: 0,
  value: 'dev-backend'
}
const _hoisted_12 = {
  key: 1,
  value: 'dev-website'
}
const _hoisted_13 = {
  key: 2,
  value: 'prod-backend'
}
const _hoisted_14 = {
  key: 3,
  value: 'prod-website'
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 'custom' }, [
  /*#__PURE__*/_createElementVNode("b", null, "Custom")
], -1))
const _hoisted_16 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        (_ctx.project.hidden)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(_ctx.project.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, "Project id: " + _toDisplayString(_ctx.project.id), 1),
      (_ctx.pkg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Package id: " + _toDisplayString(_ctx.pkg.id), 1))
        : _createCommentVNode("", true),
      (_ctx.pkg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Created: " + _toDisplayString(_ctx.updateTime), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.sortedPackagesAndSelector.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              class: "select is-small version",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pkg = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPackagesAndSelector, (pkgAndSelector, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: pkgAndSelector.pkg
                }, _toDisplayString(pkgAndSelector.version) + " " + _toDisplayString(pkgAndSelector.tags.join(',')), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.pkg]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.toAddTag = $event)),
              class: "select is-small version"
            }, [
              _hoisted_10,
              (!_ctx.latestPackageAndSelectorTags.includes('dev-backend'))
                ? (_openBlock(), _createElementBlock("option", _hoisted_11, " dev-backend "))
                : _createCommentVNode("", true),
              (!_ctx.latestPackageAndSelectorTags.includes('dev-website'))
                ? (_openBlock(), _createElementBlock("option", _hoisted_12, " dev-website "))
                : _createCommentVNode("", true),
              (!_ctx.latestPackageAndSelectorTags.includes('prod-backend'))
                ? (_openBlock(), _createElementBlock("option", _hoisted_13, " prod-backend "))
                : _createCommentVNode("", true),
              (!_ctx.latestPackageAndSelectorTags.includes('prod-website'))
                ? (_openBlock(), _createElementBlock("option", _hoisted_14, " prod-website "))
                : _createCommentVNode("", true),
              _hoisted_15
            ], 512), [
              [_vModelSelect, _ctx.toAddTag]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.load())),
              class: "button is-small"
            }, "Open"),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectAsDuplicate())),
              class: "button is-small"
            }, "Duplicate"),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rename())),
              class: "button is-small"
            }, "Rename")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}